module.exports = __webpack_public_path__ + "static/img/header-bg-9.9dd6bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-bg-9.png
// module id = m3vP
// module chunks = 2